import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e77c539"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "VisualiJSON App", -1))
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Paste JSON-string ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Paste URL ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_button = _resolveComponent("my-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_my_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/stringpaste'))),
        class: "menu__btn _big",
        "data-test": "route-stringpaste"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_my_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/linkpaste'))),
        class: "menu__btn _big",
        "data-test": "route-linkpaste"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ], 64))
}